<template>
<div class="container">
<div class="row info" v-if="info">
<div class="row">
<img :src="picurl+info.big_pic" :alt="info.name"  class="pic" v-if="info&&info.big_pic" />
</div>
<div class="row gtitle">
	<div class="col-10">
	<span class="red">¥<span class="price">{{info.price/100}}</span></span>
	<span class="oprice" v-show="info.old_price>0">¥{{info.old_price/100}}</span>
	</div>
</div>
<div class="row sum">
	<h4>{{info.name}}<span v-show="attrs.length>1">({{def.attr_value}})</span></h4>
	<p v-html="info.summary" class="summary"></p>
</div>
<div class="row what center">
	<div class="col-25"><i class="fa fa-check"></i> 诚信保证</div>
	<div class="col-25"><i class="fa fa-check"></i> 贴心服务</div>
	<div class="col-25"><i class="fa fa-check"></i> 舒适体验</div>
	<div class="col-25"><i class="fa fa-check"></i> 价格优惠</div>
</div>

</div>  <!-- info -->

<div class="row select" v-if="def" @click="select" v-show="attrs.length>1">
	<div class="col-2">已选</div>
	<div class="col-7">{{def.attr_value}}</div>
	<div class="col-1 center"><i class="fa fa-angle-right"></i></div>
</div>

<div class="row info mb" v-if="info">

<div class="row center gray more">
	<div :class="{'col-33':info.must&&info.env,'col-5':(info.must&&!info.env)||(!info.must&&info.env),red:detailindex==1}" @click="detail(1)">商品详情</div>
	<div :class="{'col-33':info.must&&info.env,'col-5':info.must&&!info.env,red:detailindex==2}" @click="detail(2)" v-if="info.must">体检须知</div>
	<div :class="{'col-33':info.muse&&info.env,'col-5':!info.must&&info.env,red:detailindex==3}" @click="detail(3)" v-if="info.env">体检环境</div>	
</div>

<div class="row detail" v-show="detailindex==1">
  <div v-html="info.content"></div>
  <div v-if="info.excel_data" class="excel">
	  <table>
		  <tr class="theader">
			<th v-for="v in info.excel_data[1]"><nobr>{{v}}</nobr></th>
		  </tr>
		  <tr v-for="(v,i) in info.excel_data" v-if="i>1">
			  <td v-for="vv in v">{{vv}}</td>
		  </tr>
	  </table>
  </div>
</div>
<div class="row detail" v-html="info.must" v-show="detailindex==2"></div>
<div class="row detail" v-html="info.env" v-show="detailindex==3"></div>

</div> <!-- 详情 -->

<div class="row buyrow center" v-if="def">
	<div class="col-2" @click="like">
	<span v-show="def.like==0"><i class="fa fa-heart-o"></i><br/></span>
	<span v-show="def.like==1"><i class="fa fa-heart red"></i><br/></span>
	收 藏
	</div>
	<div class="col-2 car" @click="linktocar">
		<span><i class="fa fa-shopping-cart"></i><br/></span>购物车
		<span v-show="car>0" class="carnum">{{car}}</span>
	</div>
	<div class="col-3" @click="select">加入购物车</div>
	<div class="col-3 buy" @click="buynow">立即购买</div>
</div>

<mt-popup v-model="showattr" position="bottom" class="attr">
	<div class="row smallimg">
		<div class="col-3"><img :src="picurl+info.big_pic" :alt="info.name" v-if="info&&info.big_pic" /></div>
		<div class="col-7">
			<div class="row">
				<h4>{{info.name}}<span v-show="attrs.length>1">({{def.attr_value}})</span></h4>
			</div>
			<div class="row smallprice">
				<span class="red">¥<span class="price">{{def.price/100}}</span></span>
	            <span class="oprice" v-show="def.oprice>0">¥{{def.oprice/100}}</span>
			</div>
		</div>
	</div>

	<div class="row gg" v-show="attrs.length>1">
		<div class="col-2 center gray">规格</div>
		<div class="col-8">
			<mt-button size="small" v-for="v in attrs" :key="v.id" @click="setattr(v)" :class="{'btn-red':v.gucode==def.gucode}">{{v.attr_value}}</mt-button>
		</div>
	</div>

	<div class="row num center">
		<div class="col-2 gray">数量</div>
		<div class="col-1" @click="dec"><i class="fa fa-minus-square"></i></div>
		<div class="col-1 truenum">{{def.gnum}}</div>
		<div class="col-1" @click="inc"><i class="fa fa-plus-square"></i></div>
	</div>
	<div class="row">
		<mt-button size="large" @click="tocar" class="lbtn">{{submit}}</mt-button>
	</div>
</mt-popup>


</div>
</template>

<style scoped>
.container{background: rgb(251,251,251);}
.info{background: white;}
.pic{width:100%;height:auto;}
.price{font-size: 1.3rem;}
.oprice{text-decoration:line-through;color:#adadad;}
.col-10{padding:.5rem;}
.gtitle,.sum{margin:.1rem 2%;width:96%;border-bottom:1px solid #eee;}
p.summary{padding:.5rem;color:#adadad;}
.what i{color:red;border:1px solid red;border-radius:50%;}
.what{font-size: small;color:#636363;padding:.5rem;}

.select{padding:.5rem .5rem .5rem 1rem;background: white;margin:.5rem 0;border-top: 1px solid #eee;border-bottom: 1px solid #eee;}
.select .col-2{color:#aaa;}
.select i{font-size: 1.3rem;color:#aaa;}
.more{border-top: 1px solid #eee;border-bottom: 1px solid #ddd;padding:.4rem;}
.detail{padding:.5rem;padding-bottom: 2rem;}
.mb{margin-bottom: 3rem;}
.buyrow{width:100%;height:3.5rem;position: fixed;bottom:0;background: white;
	border-top:1px solid #eee;
}
.car{border-left:1px solid #eee;border-right: 1px solid #eee;position: relative;}
.carnum{display:inline-block;width:1.2rem;height:1.2rem;font-size: .9rem;
	background: red;color:white;border-radius: 50%;position: absolute;top:0;right:0;}
.buy{background: red;color:white;}
.buyrow .col-2{color:#aaa;padding-top:.5rem;height:3.5rem;}
.buyrow .col-2 i{font-size: 1.2rem;}
.buyrow .col-3{height:3.5rem;line-height: 3.5rem;padding:0;}

.attr{width:100%;}
.smallimg{position: relative;}
.smallimg .smallprice{position: absolute;bottom:5%;}
.smallimg img{width:90%;margin:5%;}
.smallimg h4{height:3.4rem;overflow: hidden;}
.attr .gg{border-top: 1px solid #eee;border-bottom: 1px solid #eee;line-height: 3.6rem;}
.gg .col-2,.gg .col-8{padding:0;}
.attr .mint-button--small{margin-right: .5rem;}
.attr .num{line-height: 3.6rem;}
.num .fa{color:#ddd;font-size: 1.5rem;}
.truenum{font-size: 1.2rem;position: relative;top:-.2rem;}
.lbtn{background: red;color:white;border-radius: 0;height:3rem;line-height: 3rem;}
.btn-red{background: red;color:white;}

table td{border:1px solid #ddd;padding:.3rem;}
.excel{margin:1rem 0;}
.theader th{text-align:center;background:rgb(83,142,213);color:white;}

</style>

<script>

export default {
	data:function(){
		return {
			info:"",
			attrs:"",
			def:"",
			picurl:picurl,
			detailindex:1,
			showattr:false,
			car:0,
			submit:"加入购物车",
		}
	},
	created:function(){
        var wjtoken=this.$route.params.wjtoken;
        if(wjtoken){
            fun.cookie("wjtoken",wjtoken);
            fun.cookie("wj_goods_url",location.href);
        }
        if(fun.islogin()){
            fun.cookie("wj_goods_url",null);
        }
		fun.top();
		mydata.header=true;
		mydata.back=true;
		this.init();
	},
	methods:{
		init:function(){
			var data={
				gcode:this.$route.params.id,
				gucode:this.$route.params.gucode,
			}
			var _this=this;
			fun.post(api+"mall_detail",data,function(d){
				console.log(d);
				if(d.status==1){
					_this.car=d.info.car;
					if(d.info.info.excel_data){
						d.info.info.excel_data=JSON.parse(d.info.info.excel_data);
					}
                    _this.info=d.info.info;
                    _this.info.content=_this.info.content.replace(/\/Public\//g,window.picurl);
                    _this.info.must=_this.info.must.replace(/\/Public\//g,window.picurl);
                    _this.info.env=_this.info.env.replace(/\/Public\//g,window.picurl);
					_this.attrs=d.info.attr;
					_this.def=d.info.attr_default;
					_this.def.gnum=1;
				}else{
					_this.$toast(d.info);
				}
			})
		},
		detail:function(i){
			this.detailindex=i;
		},
		setattr:function(d){
			this.def=d;
		},
		select:function(){
			this.submit="加入购物车",
			this.showattr=true;
		},
		buynow:function(){
			this.submit="立即购买";
			this.showattr=true;
		},
		tocar:function(){
			var data={
				gucode:this.def.gucode,
				gnum:this.def.gnum,
			}
			var _this=this;
			if(this.submit=="立即购买"){
                this.buyjust(data);
                return;
            }

            fun.post(mydata.apiuser+"addtocar",data,function(d){
            	console.log(d);
            	if(d.status==1){
            		_this.car=d.info;
            		_this.showattr=false;
            	}else{
            		_this.$toast(d.info);
            	}
            })
		},
		buyjust:function(data){
			var _this=this;
            if(fun.cookie("wjtoken")){
                data.wjtoken=fun.cookie("wjtoken");
            }
			fun.post(mydata.apiuser+"buynow",data,function(d){
				console.log(d);
				if(d.status==1){
					_this.$router.push("/user/buy/"+d.info);
				}else{
					_this.$toast(d.info);
				}
			})
		},
		dec:function(){
			if(this.def.gnum>1){
				this.def.gnum--;
			}
		},
		inc:function(){
           this.def.gnum++;
		},
		like:function(){
			var data={
				gucode:this.def.gucode,
				status:this.def.like,
			}
			var _this=this;
			fun.post(mydata.apiuser+"addlike",data,function(d){
				console.log(d);
                if(d.status==1){
                	_this.def.like=_this.def.like==1?0:1;
                }else{
                	_this.$toast(d.info);
                }
			})
		},
		linktocar:function(){
			this.$router.push("/user/mycar");
		}

	}
}	
</script>


// WEBPACK FOOTER //
// src/components/mall/detail.vue